import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

export default function PrivateRoute() {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    // Mientras verificamos si hay sesión guardada
    return (
      <div className="flex items-center justify-center min-h-screen bg-softWhite text-darkBrown">
        <p className="text-lg font-medium">Cargando sesión...</p>
      </div>
    );
  }

  // Si no hay usuario después de cargar => redirigir
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si hay usuario, renderizar la ruta protegida
  return <Outlet />;
}
